module.exports = __webpack_public_path__ + "img/sky-space-milky-way-stars-110854.a23295ff.jpg";